import { render, staticRenderFns } from "./AttachmentManager.vue?vue&type=template&id=69f9564e"
import script from "./AttachmentManager.vue?vue&type=script&lang=js"
export * from "./AttachmentManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports